import React from "react";
import "./rightContentStyle.scss";
import DummyImageStyle from "../../../../assets/images/right-dummy-image.png";
import DummyImageStyle1 from "../../../../assets/images/right-dummy-image1.png";
import FourImage from "../../../../assets/images/four.png";
import { NavLink } from "react-router-dom";
export default function RightContent() {
  return (
    <div>
      <div className="nutzen-right-content-alignment">
        <div className="nutzen-right-content-box">
          <div className="nutzen-box-width">
            <h4
              className="animate__slideInUp animate__animated wow"
              data-wow-offset="100"
            >
              Nutzen Sie Ihr Kundenpotenzial für mehr Umsatz.
            </h4>
            <p
              className="animate__slideInUp animate__animated wow"
              data-wow-offset="100"
            >
              Sichern Sie sich attraktive Zusatzprovisionen:
            </p>
            <ul>
              <li
                className="animate__slideInUp animate__animated wow"
                data-wow-offset="100"
              >
                Auf Wunsch akquirieren wir Ihnen zusätzliche Immobilien zur
                Vermittlung und berechnen Ihnen dabei einen fairen Anteil von
                der erzielten Provision
              </li>
              <li
                className="animate__slideInUp animate__animated wow"
                data-wow-offset="100"
              >
                Große Immobilien-Portfolios benötigen überregionale Netzwerke
                zur Vermarktung ihrer Immobilien - einige dieser Netzwerke
                zahlen sogar Innenprovisionen
              </li>
            </ul>
          </div>
        </div>
        <div className="iamge-style">
          <NavLink to="/kontakt">
            <img
              className="animate__backInUp animate__animated wow"
              data-wow-offset="100"
              src={DummyImageStyle}
              alt="DummyImageStyle"
            />
          </NavLink>
        </div>
      </div>
      <div className="right-three-section-alignment">
        <div className="right-three-section-alignment-three-style">
          <div className="right-three-section-alignment-box">
            <div className="box-right-side-alignment">
              <h1
                className="animate__slideInUp animate__animated wow"
                data-wow-offset="100"
              >
                Starten Sie jetzt - ohne zusätzliche Verpflichtungen oder Kosten
              </h1>
              <ul>
                <li
                  className="animate__slideInUp animate__animated wow"
                  data-wow-offset="100"
                >
                  Start-Gebühren: 0 EURO
                </li>
                <li
                  className="animate__slideInUp animate__animated wow"
                  data-wow-offset="100"
                >
                  Einmalige Gebühren: 0 EURO
                </li>
                <li
                  className="animate__slideInUp animate__animated wow"
                  data-wow-offset="100"
                >
                  Sonstige Gebühren: 0 EURO
                </li>
              </ul>
              <div className="outline-primary-button">
                <NavLink to="/kontakt">
                  <button>Kontakt aufnehmen</button>
                </NavLink>
              </div>
            </div>
          </div>
          <div className="four-image-style">
            <NavLink to="/kontakt">
              <img
                className="animate__backInUp animate__animated wow"
                data-wow-offset="100"
                src={FourImage}
                alt="FourImage"
              />
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
}
